/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const styleguideViewStyle = {
  content: (theme: Theme) => ({
    backgroundColor: theme.palette.grey.A100,
    padding: "2rem",
    borderRadius: theme.shape.borderRadius,
  }),
  contentFullWidth: {
    backgroundColor: "transparent",
    padding: 0,
    width: "100%"
  }
};
